/* eslint-disable */

const preventScrolling = e => ['ArrowDown', 'ArrowUp', 'Space', 'Home', 'End'].includes(e.key) && e.preventDefault()

function Trapme(parent, childs) {
    const first = childs[0];
    const last = childs[childs.length - 1];

    const handleTabKeyPress = e => {
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
        if (e.key === 'Escape') {
            parent.removeEventListener('keydown', handleTabKeyPress);
            this.close();
        }
    };

    this.start = () => {
        first.focus();
        parent.addEventListener('keydown', handleTabKeyPress);
    }

    this.stop = () => parent.removeEventListener('keydown', handleTabKeyPress);
}

function TrapList(el) {
    let index = 0;
    let elements = [];

    const handleTabKeyPress = e => {
        if (e.key === 'ArrowDown') {
            index++;
            if (index >= elements.length) index = 0;
            elements[index].focus();
        }
        if (e.key === 'ArrowUp') {
            index--;
            if (index < 0) index = elements.length - 1;
            elements[index].focus();
        }
        if (e.key === 'Escape') {
            this.close()
        }
    };

    this.start = els => {
        index = 0;
        elements = els;
        console.log(elements);
        elements[0].focus();
        document.addEventListener('keydown', preventScrolling, { passive: false });
        el.addEventListener('keydown', handleTabKeyPress);
    }

    this.stop = () => {
        document.removeEventListener('keydown', preventScrolling);
        el.removeEventListener('keydown', handleTabKeyPress);
    }
}

function Listbox(el) {
    //https://www.w3.org/TR/2017/WD-wai-aria-practices-1.1-20170628/examples/listbox/listbox.html
    //https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-autocomplete-list/
    let index = -1;
    let elements = [];

    const setSelected = () => {
        elements.forEach(el => el.setAttribute("aria-selected", false));
        elements[index].setAttribute("aria-selected", true);
    }

    const handleTabKeyPress = e => {
        if (e.key === 'ArrowDown') {
            index++;
            if (index >= elements.length) index = 0;
            setSelected();
        }
        if (e.key === 'ArrowUp') {
            index--;
            if (index < 0) index = elements.length - 1;
            setSelected();
        }
        if (e.key === 'Escape') {
            this.close()
        }
    };

    this.start = els => {
        index = -1;
        elements = els;
        document.addEventListener('keydown', preventScrolling, { passive: false });
        el.addEventListener('keydown', handleTabKeyPress);
    }

    this.stop = () => {
        document.removeEventListener('keydown', preventScrolling);
        el.removeEventListener('keydown', handleTabKeyPress);
    }
}

function Tabpanel(tablist, tabpanels) {
    //https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
    const tabs_btn = tablist.querySelectorAll("button");
    let index = 0;
    let elements = [];

    const handleTabKeyPress = e => {
        if (e.key === 'ArrowRight') {
            index++;
            if (index >= elements.length) index = 0;
            elements[index].focus();
        }
        if (e.key === 'ArrowLeft') {
            index--;
            if (index < 0) index = elements.length - 1;
            elements[index].focus();
        }
        if (e.key === "Home") {
            index = 0;
            elements[index].focus();
        }
        if (e.key === "End") {
            index = index = elements.length - 1;
            elements[index].focus();
        }
        if (e.key === 'Escape') {
            this.close()
        }
    };

    this.setindex = value => {
        index = value;
    }

    tabs_btn.forEach((btn, i) => {
        btn.onclick = () => {
            if (btn.getAttribute("aria-selected") === "true") return;
            index = i;
            this.onclick(btn, index);
        }
        btn.onfocus = () => {
            index = i;
        }
    })

    this.display = () => {
        const selected = tabs_btn[index];
        const tabpanel = document.getElementById(selected.getAttribute("aria-controls"));
        // tabpanels.forEach(panel => panel.classList[panel === tabpanel ? "add" : "remove"]("active"));
        tabpanels.forEach(panel => {
            if (panel === tabpanel) {
                panel.setAttribute("aria-hidden", false);
                panel.classList.add("active");
            } else {
                panel.setAttribute("aria-hidden", true);
                panel.classList.remove("active");
            }
        });
        tabs_btn.forEach(btn => {
            if (btn === selected) {
                btn.removeAttribute("tabindex");
                btn.setAttribute("aria-selected", true);
            } else {
                btn.setAttribute("tabindex", -1);
                btn.setAttribute("aria-selected", false);
            }
        })
    }

    this.start = () => {
        index = 0;
        elements = tabs_btn;
        tablist.addEventListener('keydown', preventScrolling, { passive: false });
        tablist.addEventListener('keydown', handleTabKeyPress);
    }

    this.stop = () => {
        document.removeEventListener('keydown', preventScrolling);
        tablist.removeEventListener('keydown', handleTabKeyPress);
    }
}

export { Trapme, TrapList, Tabpanel, Listbox };